import planoDiretorGoianiaIcon from 'Static/images/plano-diretor-goiania.png';
import cbmgoIcon from 'Static/images/bombeirosicon.jpeg';
import abntIcon from 'Static/images/abnt.jpg';

/** Assistente usado sempre que o usuário não escolheu um especialista explicitamente. */
export const DEFAULT_ASSISTANT = 'unified';

export interface Specialist {
  id: string;
  /** Valor enviado no header `Assistant`; `undefined` usa o `DEFAULT_ASSISTANT`. */
  assistant?: string;
  labelKey: string;
  image: string;
}

/** Especialistas fixados na sidebar ("Chat AI / Sidebar / Specialists"). */
export const SIDEBAR_SPECIALISTS: Specialist[] = [
  {
    id: 'bombeiros',
    assistant: 'Bombeiros',
    labelKey: 'aiChat.library.assistants.cbmgoTitle',
    image: cbmgoIcon
  },
  {
    id: 'prefeitura-goiania',
    assistant: 'PrefeituraGoiania',
    labelKey: 'aiChat.library.assistants.goianiaTitle',
    image: planoDiretorGoianiaIcon
  },
  {
    id: 'abnt-15575',
    labelKey: 'aiChat.library.assistants.abntNbrTitle',
    image: abntIcon
  }
];

/** Opções do seletor "Especialistas" do input. */
export const INPUT_SPECIALISTS: Specialist[] = [
  {
    id: 'bombeiros',
    assistant: 'Bombeiros',
    labelKey: 'aiChat.specialistOptions.bombeiros',
    image: cbmgoIcon
  },
  {
    id: 'prefeitura-goiania',
    assistant: 'PrefeituraGoiania',
    labelKey: 'aiChat.specialistOptions.prefeituraGoiania',
    image: planoDiretorGoianiaIcon
  }
];
